import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestion = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M512 0c-282.624 0-512 229.376-512 512s229.376 512 512 512c282.624 0 512-229.376 512-512s-229.376-512-512-512zM563.2 870.4h-102.4v-102.4h102.4v102.4zM669.184 473.6l-46.080 47.104c-25.6 26.112-44.032 49.664-53.248 86.528-4.096 16.384-6.656 34.816-6.656 58.368h-102.4v-25.6c0-23.552 4.096-46.080 11.264-67.072 10.24-29.696 27.136-56.32 48.64-77.824l63.488-64.512c23.552-22.528 34.816-56.32 28.16-92.16-6.656-36.864-35.328-68.096-71.168-78.336-56.832-15.872-109.568 16.384-126.464 65.024-6.144 18.944-22.016 33.28-41.984 33.28h-15.36c-29.696 0-50.176-28.672-41.984-57.344 22.016-75.264 86.016-132.608 165.376-144.896 77.824-12.288 152.064 28.16 198.144 92.16 60.416 83.456 42.496 173.056-9.728 225.28z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgQuestion);
export default ForwardRef;
